// @ts-nocheck
import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {LANGUAGE} from '@constants/variables';
import Home from '@pages/home/Home';
import TA from '@pages/TA/TA';
import Files from '@pages/Files/Files';
import StepDetail from '@pages/StepDetail/StepDetail';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Maintenance from '@pages/Maintenance/Maintenance';
import PageForbidden from '@pages/PageForbidden/PageForbidden';
import PageNotFound from '@pages/page-not-found/PageNotFound';
import PageError from '@pages/page-error/PageError';
import {getParams, setLang} from '@src/helpers';

const LanguageHOC = ({children}: any) => {
    const dispatch = useDispatch();
    const {lang = LANGUAGE.EN} = getParams();
    useEffect(() => {
        const setLanguage = async () => {
            await setLang(dispatch, lang);
        }
        setLanguage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children
}

const App = () => {
    return (
        <Router>
            <ScrollToTop/>
            <Switch>
                <Route exact path="/">
                    <LanguageHOC><Home/></LanguageHOC>
                </Route>

                <Route path="/step-detail">
                    <LanguageHOC><StepDetail/></LanguageHOC>
                </Route>

                <Route path="/ta">
                    <TA/>
                </Route>
                <Route path="/files">
                    <Files/>
                </Route>
                <Route path="/page-error">
                    <PageError/>
                </Route>
                <Route path="/maintenance">
                    <Maintenance/>
                </Route>
                <Route path="/forbidden">
                    <LanguageHOC><PageForbidden/></LanguageHOC>
                </Route>
                <Route path="*">
                    <LanguageHOC><PageNotFound/></LanguageHOC>
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
